import React, {FC} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {
  dayhhmmToDelay,
  DDHHMM,
  DelayGranularity,
  DelayParameter,
  delayToDayHHMM,
} from '../../../editors/commons/paramModel';
import {PartialDelayParameter, toDelayParameter} from '../../slaRuleModel';
import {InputDDHHMM} from './inputDDHHMM';

/*
 * Types.
 */

interface InputDelayHHMMProps {
  granularity: DelayGranularity;
  selectedDelay?: PartialDelayParameter;
  error?: string;
  isDisabled?: boolean;
  onDelayChange: HandlerOf<DelayParameter>;
}

/*
 * Component.
 */

export const InputDelayHHMM: FC<InputDelayHHMMProps> = (props) => {
  const {granularity, selectedDelay, error, onDelayChange} = props;

  const fullDelay = selectedDelay && toDelayParameter(selectedDelay);
  const dayhhmmValue = fullDelay && delayToDayHHMM(fullDelay, granularity);

  const onChange = (dayHHMM: DDHHMM) => onDelayChange(dayhhmmToDelay(dayHHMM));

  return (
    <InputDDHHMM
      granularity={granularity}
      dayHHMM={dayhhmmValue}
      error={error}
      setDayHHMM={onChange}
      isDisabled={props.isDisabled}
    />
  );
};
